// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";


// export default function APC() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Agro Processing Cluster from MOFPI</h1>

//                                   <h2>About Agro Processing Cluster scheme Processing Cluster Scheme</h2>
//                                   <p>The scheme aims at development of modern infrastructure and common facilities to encourage group of entrepreneurs to set up food processing units based on cluster approach by linking groups of producers/ farmers to the processors and markets through well-equipped supply chain with modern infrastructure. Each Agro Processing Cluster scheme processing clusters under the scheme have two basic components i.e. Basic Enabling Infrastructure (roads, water supply, power supply, drainage, ETP etc.), Core Infrastructure/ Common facilities (ware houses, cold storages, IQF, tetra pack, sorting, grading etc) and at least 5 food processing units with a minimum investment of Rs. 25 crore. The units are set up simultaneous along with creation of common infrastructure. At least 10 acres of land is required to be arranged either by purchase or on lease for at least 50 years for setting up of Agro Processing Cluster scheme Processing Cluster. To view Indicative list of identified agri-horti production clusters (fruits & vegetables) (Click Here) and visit Geo-Sampada on spread & depth of agri-resources (Click Here)</p>
                                 
                                 
//                                 </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <p>Agro Processing Cluster scheme processing clusters set up by Project Execution Agency (PEA)/ Organisation such as Govt./ PSUs/ Joint Ventures/ NGOs/ Cooperatives/ SHGs/ FPOs/ Private Sector/ individuals etc. and are eligible for financial assistance subject to terms and conditions under the scheme guidelines.</p>
//                                   <p>The Project Execution Agency (PEA) which is responsible for overall implementation of the projects undertakes various activities including formulation of the Detailed Project Report (DPR), procurement/ purchase of land, arranging finance, creating infrastructure, ensuring external infrastructure linkages for the project etc. PEA may sell/ lease plots in Agro Processing Cluster scheme-processing cluster to other food processing units but the common facilities in the cluster cannot be sold or leased out.</p>
//                                   <p>Proposals for seeking assistance under the scheme are invited through Expression of Interest from time to time. To view notice inviting proposals (Click Here) and to submit proposals online (Click Here).</p>
                              
//                                   <h2>Project Components</h2>
//                                   <p>Basic enabling infrastructure: Includes site development, development of industrial plots, boundary wall, roads, drainage, water supply, electricity supply including power backup, effluent treatment plant, parking bay, weigh bridges, common office space etc.</p>
//                                   <p>Core infrastructure: Includes food testing laboratory, cleaning, grading, sorting and packing facilities, steam generation boilers, dry warehouse, cold storage, pre-cooling chambers, ripening chambers, IQF, specialized packaging, other common processing facilities, etc.</p>
                              
//                                   <h2>Pattern of Assistance</h2>
//                                   <p>The scheme provides grants of 35% of the eligible project costs in general areas and 50% of the eligible project costs in the north-eastern states including Sikkim and difficult areas, i.e. H. in the Himalayan states (i.e. Himachal Pradesh, Jammu and Kashmir and Uttarakhand), ITDP areas, islands and SC / ST contractors notified by the state are subject to a maximum of Rs.10.00 crore per project.</p>
//                                   <p>The grant is linked to a loan but is not supported.</p>

//                                   <h2>Release of Grant</h2>
//                                   <p>The first installment of 35% of the total approved grant will be released to the PEA after an expense of 35% of the bank loan and 35% of the promoter's contribution / capital;</p>
//                                   <p>The second installment of 40% of the total approved grant will be released after an expense of 75% of the bank loan and 75% of the promoter's contribution / capital;</p>
//                                   <p>The third installment of 15% of the approved grant is based on the completion of 90% of the project and the submission of the required documents.</p>
//                                   <p>The grant is approved after the project has been completed and the required documents have been submitted.</p>
                                  
//                                   <h2>How Enrich will help you?</h2>
//                                   <p>Planning for Agro Processing Cluster scheme Processing Cluster requires teamwork & hard work by entrepreneur and consultant both. Do not get tempted by huge amount of subsidy. Initially (before submitting EoI to MoFPI) the bank has to appraise & sanction your project and in this process bank will take into account your primary securities and collateral securities. It is the misconception that bank will appraise & sanction your project without any securities just because MoFPI is giving huge subsidies. For more details contact us</p>
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping,
  FaExclamationTriangle
} from "react-icons/fa";

export default function APC() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4">
            <Col lg={12}>
              <h1>
                Agro Processing Cluster Scheme
              </h1>

              <p>
                The Agro Processing Cluster Scheme is an initiative by the Ministry of Food Processing Industries (MoFPI)
                to promote cluster-based development of food processing industries with modern infrastructure.
              </p>

              <p>
                It connects farmers, producers, and processors through integrated supply chains,
                improving efficiency and reducing wastage.
              </p>
            </Col>
          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Objective of the Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Link farmers and processors</li>
            <li><FaCheckCircle /> Strengthen supply chain</li>
            <li><FaCheckCircle /> Promote value addition</li>
            <li><FaCheckCircle /> Reduce post-harvest losses</li>
            <li><FaCheckCircle /> Encourage cluster-based development</li>
          </ul>

          {/* FEATURES */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Key Features
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Modern infrastructure with shared facilities</li>
            <li><FaCheckCircle /> Minimum 5 processing units</li>
            <li><FaCheckCircle /> ₹25 Crore minimum investment</li>
            <li><FaCheckCircle /> Minimum 10 acres land required</li>
            <li><FaCheckCircle /> Integrated processing ecosystem</li>
          </ul>

          {/* INFRA */}
          <h2 className="section-title">
            <FaList className="icon" /> Infrastructure Components
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Roads, power, water & drainage systems</li>
            <li><FaCheckCircle /> Effluent Treatment Plant (ETP)</li>
            <li><FaCheckCircle /> Warehousing & cold storage</li>
            <li><FaCheckCircle /> Food testing labs</li>
            <li><FaCheckCircle /> Sorting, grading & packaging units</li>
            <li><FaCheckCircle /> IQF & advanced processing facilities</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Who Can Apply
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Government bodies & PSUs</li>
            <li><FaCheckCircle /> Private companies</li>
            <li><FaCheckCircle /> Joint ventures</li>
            <li><FaCheckCircle /> NGOs, SHGs & cooperatives</li>
            <li><FaCheckCircle /> FPOs & entrepreneurs</li>
          </ul>

          {/* ROLE */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Project Execution Agency (PEA)
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> DPR preparation</li>
            <li><FaCheckCircle /> Land & finance arrangement</li>
            <li><FaCheckCircle /> Infrastructure development</li>
            <li><FaCheckCircle /> Project execution & coordination</li>
          </ul>

          {/* FINANCIAL */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Financial Assistance
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 35% subsidy (general areas)</li>
            <li><FaCheckCircle /> 50% subsidy (NE & difficult areas)</li>
            <li><FaCheckCircle /> Maximum ₹10 Crores</li>
          </ul>

          {/* GRANT */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Grant Release Pattern
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 1st Installment – 35%</li>
            <li><FaCheckCircle /> 2nd Installment – 40%</li>
            <li><FaCheckCircle /> 3rd Installment – 15%</li>
            <li><FaCheckCircle /> Final after project completion</li>
          </ul>

          {/* INSIGHT */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Important Insight
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Subsidy does not guarantee bank approval</li>
            <li><FaCheckCircle /> Proper financial planning required</li>
            <li><FaCheckCircle /> Collateral & viability are important</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support including feasibility analysis,
            DPR preparation, financial structuring, application filing, and coordination with
            authorities to ensure smooth approvals.
          </p>

          {/* WHY */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Why Choose Us
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Strategic project planning</li>
            <li><FaCheckCircle /> Bankable DPR preparation</li>
            <li><FaCheckCircle /> Faster approvals</li>
            <li><FaCheckCircle /> Risk minimization</li>
            <li><FaCheckCircle /> End-to-end execution support</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}